<template>
  <div class="tab">
    <h3>抽样方案</h3>
    <div>
      <div>
        <b>被试与抽样：</b>
        <p>分层多阶段方便取样</p>
        <img src="../../assets/sampling.png" alt />
      </div>
      <div>
        <img src="../../assets/corner.png" alt />
        <p>
          <b>省份：</b>依据“中国发展指数”，从四类省份中进行选取
        </p>
        <p class="p2">
          <b>区县：</b>依据中国教育经济发展指数，各省选取发展优良和较差的区县各1所
        </p>
        <p class="p3">
          <b>学校：</b>以方便取样方法，每个区县选择小学、初中和高中各一所
        </p>
        <p class="p4">
          <b>学生：</b>方便取样，每个年级各150人（小学4-5年级，初一初二年级，高一高二年级）
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sampling",
  data() {
    return {};
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab > div > div {
  display: inline-block;
  vertical-align: top;
}
.tab > div > div:first-child {
  width: 40%;
}
.tab > div > div:last-child {
  width: 58%;
  position: relative;
  margin-top: 30px;
}
.tab > div > div:first-child>p{
  margin: 10px 0 30px;
  text-indent: 2em;
  font-family: sans-serif
}
.tab > div > div:last-child > img {
  position: absolute;
  left: -160px;
}
.tab > div > div>p{
  font-family: sans-serif
}
.tab > div > div:last-child>p{
  height: 80px;
  margin-left: 95px;
  font-family: sans-serif
}
.tab > div > div>p.p2{
  margin-left: 170px;
}
.tab > div > div>p.p3{
  margin-left: 245px;
}
.tab > div > div>p.p4{
  margin-left: 320px;
}
</style>




// WEBPACK FOOTER //
// src/components/tabs/sampling.vue